module.exports = __webpack_public_path__ + "static/wisense.c79fb518.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/clients/images/wisense.png
// module id = ./src/app/data/clients/images/wisense.png
// module chunks = 1 2 3